import appConfig from '../const/config';

const prefix = `${process.env.PUBLIC_URL}/video/${appConfig.locale}/`;
const catalogPrefix = `${process.env.PUBLIC_URL}/video/${appConfig.locale}/catalog/`;
const prefixWithoutLocale = `${process.env.PUBLIC_URL}/video/`;

export const BG = {
    file:  prefixWithoutLocale + 'index-hud.mp4',
    // vimeo_id: '376568191',
    title: '',
    name:  '',
};

export const bg_factory_2 = {
    // file:  prefix + 'zeto-scheme.mp4',
    file:  prefix + 'factory-bg.mp4',
    // vimeo_id: '376670553',
    title: '',
    name:  '',
};

// export const bg_center = {
//     file:  prefixWithoutLocale + 'hud-ispytatelnyy-tsentr.mp4',
//     // vimeo_id: '376670862',
//     title: '',
//     name:  '',
// };

export const bg_podstancii = {
    file:  prefixWithoutLocale + 'podstancii-bg.mp4',
    // vimeo_id: '376670689',
    title: '',
    name:  '',
};

export const bg_prod = {
    file:  prefixWithoutLocale + 'prod-bg.mp4',
    // file:  prefixWithoutLocale + 'hud-oborudovaniye.mp4',
    // vimeo_id: '376670689',
    title: '',
    name:  '',
};

export const bg_kooperatsiya = {
    file:  prefixWithoutLocale + 'kooperatsiya-bg.mp4',
    // vimeo_id: '376670689',
    title: '',
    name:  '',
};

// export const project_map = {
//     file:  prefixWithoutLocale + 'map-full.webm',
//     // vimeo_id: '376568191',
//     title: '',
//     name:  '',
// };

export const driver = {
    file:  prefixWithoutLocale + 'driver-snd.mp4',
    // vimeo_id: '376634247',
    title: '',
    name:  '',
};

// О заводе, производство
// /factory/about
export const factory2_prod = {
    // file:  prefix + 'factory2_prod.webm',
    file:  prefix + 'factory2_prod.mp4',
    vimeo: {
        ru: '692527013',
        en: '692530343'
    },
    title: '',
    name:  '',
};

// Строительство и монтаж
// /factory/building
export const factory2Building = {
    file:  prefix + 'factory2_building.mp4',
    vimeo: {
        ru: '692526077',
        en: '692530388'
    },
    title: '',
    name:  '',
};

// Гарантии и сервис
// /factory/warranty
export const factory2Warranty = {
    file:  prefix + 'factory2_warranty.mp4',
    vimeo: {
        ru: '692526291',
        en: '692530369'
    },
    title: '',
    name:  '',
};

// Испытания
// /factory/trials
export const factory2_isp = {
    file:  prefix + 'factory2_isp.mp4',
    vimeo: {
        ru: '692524273',
        en: '692528932'
    },
    title: '',
    name:  '',
};

// Разработка и проектирование
// /factory/dev
export const factory2Dev = {
    file:  prefix + 'factory2_dev.mp4',
    vimeo: {
        ru: '692524263',
        en: '692528919'
    },
    title: '',
    name:  '',
};

// Кооперация и инновации
// Дата центр
export const kooperCenter = {
    file:  prefix + 'kooper-center.mp4',
    vimeo: {
        ru: '692527453',
        en: '692531336'
    },
    title: '',
    name:  '',
};

// Кооперация и инновации
// Технопарк
export const kooperPark = {
    file:  prefix + 'kooper-park.mp4',
    vimeo: {
        ru: '692527428',
        en: '692531321'
    },
    title: '',
    name:  '',
};

// Кооперация и инновации
// Кластер
export const kooperCluster = {
    file:  prefix + 'kooper-cluster.mp4',
    vimeo: {
        ru: '692527475',
        en: '692531370'
    },
    title: '',
    name:  '',
};

// export const podst110 = {
//     file:  prefixWithoutLocale + 'podst110.webm',
//     // vimeo_id: '',
//     title: '',
//     name:  '',
// };

// temp
export const podst110_main = {
    file:  prefixWithoutLocale + 'podst110_main.mp4',
    vimeo_id: '491649717',
    title: '',
    name:  '',
};

export const podst110_bg = {
    file:  prefixWithoutLocale + 'podst110_bg.mp4',
    // vimeo_id: '376620443',
    title: '',
    name:  '',
};

export const podst110_prod1_zoom = {
    file:  prefixWithoutLocale + 'podst110_prod1_zoom.mp4',
    vimeo_id: '491649900',
    title: '',
    name:  '',
};

export const podst110_prod1_detail = {
    file:  prefixWithoutLocale + 'podst110_prod1_detail.mp4',
    vimeo_id: '491649987',
    title: '',
    name:  '',
};

export const podst110_prod2_zoom = {
    file:  prefixWithoutLocale + 'podst110_prod2_zoom.mp4',
    vimeo_id: '491650135',
    title: '',
    name:  '',
};

export const podst110_prod2_detail = {
    file:  prefixWithoutLocale + 'podst110_prod2_detail.mp4',
    vimeo_id: '491650148',
    title: '',
    name:  '',
};

export const podst110_prod3_zoom = {
    file:  prefixWithoutLocale + 'podst110_prod3_zoom.mp4',
    vimeo_id: '491650370',
    title: '',
    name:  '',
};

export const podst110_prod3_detail = {
    file:  prefixWithoutLocale + 'podst110_prod3_detail.mp4',
    vimeo_id: '491650466',
    title: '',
    name:  '',
};

export const podst110_prod4_zoom = {
    file:  prefixWithoutLocale + 'podst110_prod4_zoom.mp4',
    vimeo_id: '491650491',
    title: '',
    name:  '',
};

export const podst110_prod4_detail = {
    file:  prefixWithoutLocale + 'podst110_prod4_detail.mp4',
    vimeo_id: '493382161',
    title: '',
    name:  '',
};

// export const podst220 = {
//     file:  prefixWithoutLocale + 'podst220.webm',
//     // vimeo_id: '488934907',
//     title: '',
//     name:  '',
// };

export const podst220_main = {
    file:  prefixWithoutLocale + 'podst220_main.mp4',
    vimeo_id: '488934907',
    title: '',
    name:  '',
};

export const podst220_bg = {
    file:  prefixWithoutLocale + 'podst220_bg.mp4',
    // vimeo_id: '376620443',
    title: '',
    name:  '',
};

// export const podst330 = {
//     file:  prefixWithoutLocale + 'podst330.mp4',
//     vimeo_id: '491648260',
//     title: '',
//     name:  '',
// };

// temp
export const podst330_main = {
    file:  prefixWithoutLocale + 'podst330_main.mp4',
    vimeo_id: '491648260',
    title: '',
    name:  '',
};

export const podst330_bg = {
    file:  prefixWithoutLocale + 'podst330_bg.mp4',
    // vimeo_id: '376620443',
    title: '',
    name:  '',
};

export const podst330_prod1_zoom = {
    file:  prefixWithoutLocale + 'podst330_prod1_zoom.mp4',
    vimeo_id: '491648509',
    title: '',
    name:  '',
};

export const podst330_prod1_detail = {
    file:  prefixWithoutLocale + 'podst330_prod1_detail.mp4',
    vimeo_id: '491648728',
    title: '',
    name:  '',
};

export const podst330_prod2_zoom = {
    file:  prefixWithoutLocale + 'podst330_prod2_zoom.mp4',
    vimeo_id: '491648888',
    title: '',
    name:  '',
};

export const podst330_prod2_detail = {
    file:  prefixWithoutLocale + 'podst330_prod2_detail.mp4',
    vimeo_id: '491648996',
    title: '',
    name:  '',
};

export const podst330_prod3_zoom = {
    file:  prefixWithoutLocale + 'podst330_prod3_zoom.mp4',
    vimeo_id: '491649075',
    title: '',
    name:  '',
};

export const podst330_prod3_detail = {
    file:  prefixWithoutLocale + 'podst330_prod3_detail.mp4',
    vimeo_id: '491649132',
    title: '',
    name:  '',
};

export const podst330_prod4_zoom = {
    file:  prefixWithoutLocale + 'podst330_prod4_zoom.mp4',
    vimeo_id: '491649322',
    title: '',
    name:  '',
};

export const podst330_prod4_detail = {
    file:  prefixWithoutLocale + 'podst330_prod4_detail.mp4',
    vimeo_id: '491649462',
    title: '',
    name:  '',
};

// new map
export const map_out = {
    file:  prefixWithoutLocale + 'map/out.mp4',
    title: '',
    name:  '',
};

// new map
export const map_out_cycle = {
    file:  prefixWithoutLocale + 'map/out_cycle.mp4',
    title: '',
    name:  '',
};

export const map_perehod1 = {
    file:  prefixWithoutLocale + 'map/perehod1.mp4',
    title: '',
    name:  '',
};

export const map_perehod2 = {
    file:  prefixWithoutLocale + 'map/perehod2.mp4',
    title: '',
    name:  '',
};

export const map_perehod3 = {
    file:  prefixWithoutLocale + 'map/perehod3.mp4',
    title: '',
    name:  '',
};

export const map_perehod4 = {
    file:  prefixWithoutLocale + 'map/perehod4.mp4',
    title: '',
    name:  '',
};

export const map_1zoom = {
    file:  prefixWithoutLocale + 'map/1zoom.mp4',
    title: '',
    name:  '',
};

export const map_2zoom = {
    file:  prefixWithoutLocale + 'map/2zoom.mp4',
    title: '',
    name:  '',
};

export const map_3zoom = {
    file:  prefixWithoutLocale + 'map/3zoom.mp4',
    title: '',
    name:  '',
};

export const map_4zoom = {
    file:  prefixWithoutLocale + 'map/4zoom.mp4',
    title: '',
    name:  '',
};

export const product_id_9 = {
    file:  catalogPrefix + 'KREU_110.mp4',
    vimeo_id: '699100881',
    title: '',
    name:  '',
};